import { toast } from "sonner";
import { slugify } from "@/lib/api";

/** Share a product via the native Web Share API, falling back to copy-link. */
export async function shareProduct(p) {
  const url = `${window.location.origin}/product/${p.slug || slugify(p.name)}`;
  if (navigator.share) {
    try {
      await navigator.share({ title: p.name, text: `${p.name} — ${p.price}`, url });
      return;
    } catch (e) {
      if (e?.name === "AbortError") return; // user cancelled the share sheet
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied");
  } catch {
    window.prompt("Copy this link:", url);
  }
}
